var copyPasteOnlyInput = function (e) {
    var allowedKeys = ["c", "v", "x"];
    var allow = (e.metaKey || e.ctrlKey) && allowedKeys.includes(e.key);
    if (!allow) {
        e.preventDefault();
    }
};
export default copyPasteOnlyInput;
//# sourceMappingURL=copyPasteOnlyInput.js.map